module.exports = __webpack_public_path__ + "static/media/lato-black.48d738bb.ttf";